var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"#fff","fill-rule":"nonzero","d":"M7 10l5 5 5-5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }